import api from './api';

// Tüm üniversiteleri getir
export const getUniversities = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.city) params.append('city', filters.city);
    if (filters.type) params.append('type', filters.type);
    
    const response = await api.get(`/universities?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Get universities error:', error);
    throw error.response?.data || error;
  }
};

// Bölüm ara (autocomplete)
export const searchDepartments = async (query, filters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('q', query);
    if (filters.scoreType) params.append('scoreType', filters.scoreType);
    if (filters.universityId) params.append('universityId', filters.universityId);
    if (filters.limit) params.append('limit', filters.limit);
    
    const response = await api.get(`/departments/search?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Search departments error:', error);
    throw error.response?.data || error;
  }
};

// Üniversitenin bölümlerini getir
export const getUniversityDepartments = async (universityId, scoreType = null) => {
  try {
    const params = new URLSearchParams();
    if (scoreType) params.append('scoreType', scoreType);
    
    const response = await api.get(`/universities/${universityId}/departments?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Get university departments error:', error);
    throw error.response?.data || error;
  }
};

// Bölüm detayı getir
export const getDepartmentDetail = async (departmentId) => {
  try {
    const response = await api.get(`/departments/${departmentId}`);
    return response.data;
  } catch (error) {
    console.error('Get department detail error:', error);
    throw error.response?.data || error;
  }
};

// Popüler bölümleri getir
export const getPopularDepartments = async (scoreType = null, limit = 10) => {
  try {
    const params = new URLSearchParams();
    if (scoreType) params.append('scoreType', scoreType);
    params.append('limit', limit);
    
    const response = await api.get(`/departments/popular?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Get popular departments error:', error);
    throw error.response?.data || error;
  }
};
